import { eachMonthOfInterval, addMonths, format, parse } from "date-fns";
import { DATE_FNS_DATE_ONLY_FORMAT } from "../common/constants";
import { ClinicsEnum } from "../common/enums";
import {ClinicBlockAvailabilityForDates, ClinicBlockAvailability } from "../common/ParseEventsToAvailability";
import { DataIntegrityReport } from "../common/types";
import Alert from "./Alert";
import Month from "./Month";
import SpecialtyClinicButtonGroup from "./SpecialtyClinicButtonGroup";


type CalendarComponentProps = {
  availabilityInfoForEachDay: ClinicBlockAvailabilityForDates,
  isDoingFirstLoad: boolean,
  isDoingFirstSpecialtyClinicLoad: boolean,
  selectedClinic: ClinicsEnum | undefined,
  setSelectedClinic: (selectedClinic: ClinicsEnum | undefined) => void
  anyWarningAboutDataFeedsUsed : DataIntegrityReport | undefined
}

export default function CalendarComponent(props: CalendarComponentProps) {
  const mappedAvailabilities: {date: string, clinicBlockAvailability: ClinicBlockAvailability[] }[] = [];

  props.availabilityInfoForEachDay.forEach((clinicBlockAvailability, date) => {
    if (clinicBlockAvailability.some(block => block.availableSlots.length)) {
      mappedAvailabilities.push({
        date,
        clinicBlockAvailability
      })
    }
  })

  function eventsForSelectedDay(dateString: string) {
    const clinicBlocksForDay = props.availabilityInfoForEachDay.get(dateString)
    if (clinicBlocksForDay) {
      const availableSlotsText = clinicBlocksForDay.map(clinicBlock => {
        return clinicBlock.availableSlots.map(availableSlot => {
          const availableTimeSlotText = `${format(availableSlot.startDateUTCMilliseconds, "hh:mm a")} - ${format(availableSlot.endDateUTCMilliseconds,"hh:mm a")} ${clinicBlock.isHygieneWeek ? " & HYGIENE" : ""}`
          const unavailabilityState = clinicBlock.unavailabilityState;
          const unavailabilityMessage = clinicBlock.unavailiabilityMessage
          const chairsAvailableText = clinicBlock.chairsAvailable ? `${clinicBlock.chairsAvailable} chair${clinicBlock.chairsAvailable===1 ? '' : 's'} at ` : "";
          return <li key={availableSlot.startDateUTCMilliseconds}>{chairsAvailableText} {availableTimeSlotText} {unavailabilityState} {unavailabilityMessage} </li>
        })       
      }).flat();

      if (availableSlotsText.length > 0) {
        return availableSlotsText;
      }
    }

    return <p>There are no availabilities</p>
  }

// function newFeatureAlert(message:string){
//   return <div id="alert-5" className="tw-flex tw-p-4 tw-mb-4  tw-text-blue-700  tw-bg-blue-100  tw-rounded-lg  tw-dark:bg-gray-800  tw-dark:text-blue-300" role="alert">
//    <div className="tw-p-2 tw-items-center tw-text-indigo-100 tw-leading-none tw-lg:rounded-full tw-flex tw-lg:inline-flex" role="alert">
//     <span className="tw-flex tw-rounded-full tw-bg-indigo-500 tw-uppercase tw-px-2 tw-py-1 tw-text-xs tw-font-bold tw-mr-3">New</span>
//     <span className="tw-flex tw-text-blue-700  tw-bg-blue-100  tw-rounded-lg  tw-dark:bg-gray-800  tw-dark:text-blue-300">  {message}</span>
//   </div>
//   <button type="button" className=" tw-ml-auto  tw--mx-1.5  tw-my-1.0  tw-bg-blue-100  tw-text-blue-500  tw-rounded-lg  tw-focus:ring-2  tw-focus:ring-blue-400  tw-p-1.5  tw-hover:bg-blue-200  tw-inline-flex  tw-h-8  tw-w-8  tw-dark:bg-gray-800  tw-dark:text-blue-300  tw-dark:hover:bg-gray-700" data-dismiss-target="#alert-5" aria-label="Close">
//     <span className=" tw-sr-only">Close</span>
//     <svg aria-hidden="true" className=" tw-w-5  tw-h-5" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd"></path></svg>
//   </button>
// </div>;
// }  
function buildAlertIfDataFeedQuestionable(){
//  const testData = ["Date: 13/12/23 | chairs: 6","Date: 10/13/23 | chairs six", "Date: 10/13/23 | chairs: X"]
//  const listSource = testData;
 const listSource = props.anyWarningAboutDataFeedsUsed?.possiblyHumanInterperableAmbiguities;
 const numPossiblyHumanInterperableAmbiguities = listSource?.length
 return <Alert variant={"yellow"}>
    <p>{props.anyWarningAboutDataFeedsUsed?.errorSummary}</p>
    {(numPossiblyHumanInterperableAmbiguities !== undefined && 
    numPossiblyHumanInterperableAmbiguities > 0 ) &&
    <div className="tw-px-5 tw-mt-1">
      <ol>
        {listSource!.slice(0,3).map(x=><li>{x}</li>)}
        {numPossiblyHumanInterperableAmbiguities>3 && <p>...etc</p>}
      </ol>
    </div>
    }
  </Alert>
  
}

  return (
    <>
    
      {/* {newFeatureAlert(" Now including closures from excel")} */}
      <div className="tw-py-3">
        <SpecialtyClinicButtonGroup isLoading={props.isDoingFirstSpecialtyClinicLoad} value={props.selectedClinic} onChange={props.setSelectedClinic} />
        {props.anyWarningAboutDataFeedsUsed?.errorSummary && buildAlertIfDataFeedQuestionable()}
      </div>

      <div className="tw-flex tw-items-start tw-flex-col md:tw-flex-row tw-overflow-auto md:tw-overflow-visible tw-relative md:tw-space-x-10 md:tw-space-y-0">
        <div className="tw-space-y-0 md:tw-space-x-0 md:tw-space-y-10 tw-flex tw-overflow-x-auto md:tw-flex-col tw-snap-x tw-w-full tw-pb-5 tw-flex-1 tw-snap-mandatory tw-scroll-smooth">
          {
            eachMonthOfInterval({
              start: new Date(),
              end: addMonths(new Date(), 3)
            }).map((month, index) => (
              <div id={`month-${index}`} className="tw-flex">
                <Month
                  key={month.toString()}
                  isDoingFirstLoad={props.isDoingFirstLoad}
                  availabilityInfoForEachDay={props.availabilityInfoForEachDay}
                  monthStartDate={month}
                  className="tw-min-w-[300px] tw-max-w-[600px] tw-w-full tw-snap-center"
                  selectDate={(date) => {
                    const formattedDate = format(date, DATE_FNS_DATE_ONLY_FORMAT);
                    var getMeTo = document.getElementById(formattedDate);
                    getMeTo?.scrollIntoView({behavior: "smooth", block: "nearest"});
                  }}
                />
                {
                  index < 3 && <div className="tw-animate-pulse md:tw-hidden tw-mx-4 tw-flex tw-justify-center tw-items-center">
                    <svg onClick={() => window.location.replace(`#month-${index+1}`)} className="tw-w-6 tw-h-6 tw-text-blue-500 tw--rotate-90 tw-cursor-pointer" fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" viewBox="0 0 24 24" stroke="currentColor">
                      <path d="M19 14l-7 7m0 0l-7-7m7 7V3"></path>
                    </svg>
                  </div>
                }
              </div>
            ))
          }
        </div>
        <div className="tw-sticky tw-top-32 tw-left-0 tw-w-full md:tw-w-auto">
          <h1 className="tw-font-bold tw-text-base tw-sticky tw-top-0 tw-py-4">Available Times</h1>
          <div className="tw-w-full md:tw-w-72 tw-flex tw-flex-col tw-space-y-4 tw-overflow-y-scroll tw-h-96 tw-overflow-scroll tw-pr-4">
            {
              mappedAvailabilities.map(day => (
                <div key={day.date} id={day.date}>
                  <h2 className="tw-font-semibold tw-text-base tw-bg-slate-200 dark:tw-bg-slate-700 tw-pt-4 tw-px-4 tw-pb-2 tw-mb-2">{format(parse(day.date, DATE_FNS_DATE_ONLY_FORMAT, new Date()), 'MMMM d, yyyy')}</h2>
                  <ul className="tw-space-y-4 tw-text-gray-700 dark:tw-text-slate-100 tw-pl-4">
                    {eventsForSelectedDay(day.date)}
                  </ul>
                </div>
              ))
            }
          </div>
        </div>
      </div>
    </>
  )
}